export default {
  Summary: "summary",
  Movement: "movement",
  MeterReading: "meter-reading",
  AuditTrail: "audit-trail",
};
